module.exports = __webpack_public_path__ + "static/media/dj-rest-framework.37921ea7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dj-rest-framework.png
// module id = 160
// module chunks = 0